import React from "react";
import { Section, FadeUp, SectionHeading, CheckItem, CtaButton } from "./primitives";
import { problemChecklist } from "@/data/content";

export const Problem = () => (
  <Section className="bg-white">
    <div className="max-w-[720px] mx-auto text-center">
      <FadeUp>
        <SectionHeading>Does This Sound Like You?</SectionHeading>
      </FadeUp>
      <FadeUp delay={0.05}>
        <ul className="mt-10 space-y-5 text-left max-w-[600px] mx-auto">
          {problemChecklist.map((item) => (
            <CheckItem key={item}>{item}</CheckItem>
          ))}
        </ul>
      </FadeUp>
      <FadeUp delay={0.1}>
        <p className="mt-12 text-2xl font-bold text-zinc-900">You're not alone.</p>
        <div className="mt-6 space-y-5 text-lg md:text-xl text-zinc-600 leading-relaxed">
          <p>If you're like most intermediate rock guitarists, you've already practised for years.</p>
          <p>You've watched videos, read books, taken courses, maybe even had one-on-one lessons.</p>
          <p>But your playing still falls back into the same old patterns, and your technique still feels stuck.</p>
          <p>
            That's because most guitarists collect more information, learn more licks, desperately push the
            metronome up, and hope that one day it all turns into fast, fluid lead playing.
          </p>
          <p>But it usually doesn't.</p>
        </div>
      </FadeUp>
      <FadeUp delay={0.15}>
        <div className="mt-12">
          <CtaButton testid="cta-problem-apply" />
        </div>
      </FadeUp>
    </div>
  </Section>
);
